import React, { createRef } from 'react'

//UI
import { Grid, Tab, Tabs, Button } from '@material-ui/core'
//Components
import BiotrackLocations from './BiotrackLocations'
import EditActionComponent from '../common/EditActionComponent'
import ModalDialog from '../common/ModalDialog'
//Utils
import { createCopy } from '../../utils/common'
import MetrcMergedFacilities from './MetrcMergedFacilites'
import MetrcEmployees from '../Metrc/MetrcEmployees'
import AddMetrcEmployeeModal from '../Metrc/AddMetrcEmployeeModal'
import { getShopList } from '../../actions/shop'
import { openErrorMessage } from '../../actions/message'
import _ from 'lodash'
import { deletedMerchantEmployeeKey, updateMerchant, updateMerchantEmployeeKey } from '../../api/complianceService'
import { complianceMerchantEnvironment } from '../../utils/constants'
import { buildRequestEmployeeMetrcKey } from '../../utils/requestEmployeeMetrcKey'

export default class Compliance extends React.PureComponent {
  addMetrcEmployeeModal = createRef()

  onChangeActiveTab = (_, val) => {
    this.props.onChangeActiveTab(val)
  }

  onChangeLocation = (id, key, isCheckBox) => {
    return (e) => {
      const { data } = this.props
      const value = isCheckBox ? e.target.checked : e.target.value
      const locations = createCopy(data.locations)

      const location = locations.find((location) => location.id === id)
      const pos = locations.findIndex((l) => l.id === location.id)

      locations[pos] = {
        ...location,
        [key]: value,
      }

      this.props.onChange('locations', locations)
    }
  }

  onChangeFacility = (id, key, isCheckBox, packageLocationFlag = false) => {
    return (e) => {
      const { data, facilitiesOptions = [] } = this.props
      const value = isCheckBox ? e.target.checked : e.target.value
      const facilities = createCopy(data.facilities)

      const facility = facilities.find((facility) => facility.id === id)
      const pos = facilities.findIndex((f) => f.id === facility.id)
      facilities[pos] = {
        ...facility,
        [key]: value,
      }

      let {
        enablePackageLocationTracking = false,
        facLicense = '',
        stateCode = '',
      } = facilities[pos]
      if (enablePackageLocationTracking) {
        let metrcFacility = _.find(facilitiesOptions[stateCode] || [], {
          License: { Number: facLicense },
        })
        if (key === 'facLicense') {
          facilities[pos]['enablePackageLocationTracking'] =
            metrcFacility.FacilityType.canUpdateLocationsOnPackages
          facilities[pos]['enablePackageLocationTracking'] &&
            this.props.dispatch(
              openErrorMessage(
                'WARNING: Metrc Package Location Tracking is Enabled.  If you change your METRC facility, you will delete your Metrc default location and your inventory-to-compliance room mappings.',
              ),
            )
        }
        if (key === 'enablePackageLocationTracking' && value) {
          this.props.dispatch(
            openErrorMessage(
              'WARNING: Package tracking feature enabled. You must set a new default metrc location. Check below this table to confirm if you have a default metrc location!',
            ),
          )
        }
      }
      this.props.onChange('facilities', facilities)
    }
  }

  onAddNewLocation = (data) => {
    const locations = createCopy(this.props.data.locations)
    locations.push(data)
    this.props.onChange('locations', locations)
  }

  onAddNewFacility = (data) => {
    const facilities = createCopy(this.props.data.facilities)
    facilities.push(data)
    this.props.onChange('facilities', facilities)
  }

  onSave = () => {
    this.props.onSave((_) => this.props.disableEdit())
  }

  onFacilititesSave = () => {
    this.props.onFacilititesSave(this.props.data, (_) => {
      this.props.disableEdit()
      this.props.dispatch(getShopList())
      const {facilities = []} = this.props.data;
      this.updateMetrcDataForMerchants(facilities)
    })
  }

  updateMetrcDataForMerchants = (facilities) => {
    facilities.filter((facility) => facility.environment && facility.facLicense && facility.userApiKey)
    .forEach((facility) => {
      const {environment, facLicense, userApiKey, companyId, shopId, stateCode} = facility;
      const request = {
        data: {
          type: "compliance_merchants",
          attributes: {
            stateOrProvince: stateCode,
            credentials: [
              {
                complianceType: "METRC",
                clientId: facLicense,
                clientSecret: userApiKey,
                environment: complianceMerchantEnvironment[environment]
              }
            ]
          }
        }
      }
      updateMerchant(companyId,shopId, request)
    })
  }

  checkApiKey = (id) => () => {
    const { data } = this.props
    const facilities = createCopy(data.facilities)

    const facility = facilities.find((facility) => facility.id === id)

    //this.onFacilititesSave();
    this.props.searchFacilities(facility.environment, facility.stateCode, facility.userApiKey)
    this.props.enableEdit()
  }

  onCancel = () => {
    this.props.onCancel()
  }

  openMetrcEmployeeModal = () => {
    this.addMetrcEmployeeModal.current.handleClickOpen()
  }

  openDeleteModal = (employeeKey) => {
    this.props.setEmployeeKeyForDelete(employeeKey)
    this.deleteModal.handleClickOpen()
  }

  onSaveEmployeeKey = (request) => {
    if (this.props.validateEmployeeKey(request)) {
      this.props.saveEmployeeKey(request).then((res) => {
        this.props.onSearchEmployeeKey()
        this.updateEmployeeMetrcKeyForMerchants(res)
        this.addMetrcEmployeeModal.current.handleClose()
      })
    }
  }

  updateEmployeeMetrcKeyForMerchants = (data) => {
    const { userApiKey, companyId, employeeId, enabled } = data
    const request = buildRequestEmployeeMetrcKey(userApiKey, enabled)
    updateMerchantEmployeeKey(companyId, employeeId, request)
  }

  onDeleteEmployeeKey = () => {
    const { selectedEmployeeKey = {} } = this.props
    if (selectedEmployeeKey && selectedEmployeeKey.id) {
      this.props.deleteEmployeeKey(selectedEmployeeKey.id).then((res) => {
        const { companyId, employeeId } = selectedEmployeeKey
        deletedMerchantEmployeeKey(companyId, employeeId)
        this.props.onSearchEmployeeKey()
        this.deleteModal.handleClose()
      })
    }
  }

  render() {
    const {
      data,
      editMode,
      shops = [],
      TABS,
      activeTab,
      facilitiesOptions = {},
      retrieveFacilities,
      metrcLocationTypes,
      employees = [],
      metrcEmployeeKeys = [],
      enableEmployeeMetrcKey = false,
      selectedEmployeeKey = {},
      shop,
    } = this.props

    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12} sm={7} md={7} lg={7} className="cus_tabs">
            {true ? (
              <Tabs
                value={activeTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={this.onChangeActiveTab}
              >
                <Tab label="BioTrack Locations" value={TABS.BIOTRACK_LOCATIONS} />
                <Tab label="Metrc Facilities" value={TABS.METRC_FACILITIES} />
                {enableEmployeeMetrcKey ? (
                  <Tab label="Metrc Employees" value={TABS.METRC_EMPLOYEE_KEYS} />
                ) : null}
              </Tabs>
            ) : null}
          </Grid>
          <Grid item xs={3} sm={3} md={3} lg={3}>
            {activeTab === TABS.BIOTRACK_LOCATIONS ? (
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            ) : null}
            {activeTab === TABS.METRC_FACILITIES ? (
              <EditActionComponent
                onSave={this.onFacilititesSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            ) : null}
            {activeTab === TABS.METRC_EMPLOYEE_KEYS ? (
              <div className="pull-right margin-bottom-small margin-top">
                <Button onClick={this.openMetrcEmployeeModal} className="primary-button margin">
                  Add Employee Key
                </Button>
              </div>
            ) : null}
          </Grid>
        </Grid>
        {activeTab === TABS.BIOTRACK_LOCATIONS ? (
          <BiotrackLocations
            data={data}
            shops={shops}
            onChangeLocation={this.onChangeLocation}
            editMode={editMode}
            onAddNewLocation={this.onAddNewLocation}
          />
        ) : null}
        {activeTab === TABS.METRC_FACILITIES ? (
          <MetrcMergedFacilities
            onChangeFacility={this.onChangeFacility}
            onAddNewFacility={this.onAddNewFacility}
            retrieveFacilities={retrieveFacilities}
            facilitiesOptions={facilitiesOptions}
            checkApiKey={this.checkApiKey}
            data={data}
            editMode={editMode}
            shops={shops}
            shop={shop}
            metrcLocationTypes={metrcLocationTypes}
            dispatch={this.props.dispatch}
          />
        ) : null}
        {activeTab === TABS.METRC_EMPLOYEE_KEYS ? (
          <React.Fragment>
            <MetrcEmployees
              data={data}
              editMode={editMode}
              shops={shops}
              facilitiesOptions={facilitiesOptions}
              onChangeFacility={this.onChangeFacility}
              checkApiKey={this.checkApiKey}
              metrcEmployeeKeys={metrcEmployeeKeys}
              onUpdateEmployeeKey={this.props.onUpdateEmployeeKey}
              searchTerm={this.props.searchTerm}
              onSearchEmployeeKey={this.props.onSearchEmployeeKey}
              onChangeTerm={this.props.onChangeTerm}
              onDelete={this.openDeleteModal}
            />
            <AddMetrcEmployeeModal
              ref={this.addMetrcEmployeeModal}
              employees={employees}
              onEmployeeSearch={this.props.onEmployeeSearch}
              onSaveEmployeeKey={this.onSaveEmployeeKey}
            />
            <ModalDialog
              ref={(c) => (this.deleteModal = c)}
              onConfirm={this.onDeleteEmployeeKey}
              confirmText="delete"
            >
              Are you sure you want to delete '
              {(selectedEmployeeKey && selectedEmployeeKey.employeeName) || ''}' key?
            </ModalDialog>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/Compliance.js